import StreamingError, {
  StreamingErrorCodes,
} from '../abstract/StreamingError';

class ReTradingErrorCodes extends StreamingErrorCodes {
  // New Trading Codes
  static QUOTE_TRADE_INVALID_STATE = 'QUOTE_TRADE_INVALID_STATE';
  static QUOTE_TRADE_ALLOCATION_TERMINATION =
    'QUOTE_TRADE_ALLOCATION_TERMINATION';

  // TODO: need to check if it is needed here
  static QUOTE_REJECT = 'QUOTE_REJECT';
  static QUOTE_REQUEST_REJECT = 'QUOTE_REQUEST_REJECT';
}

export default class ReTradingError extends StreamingError {
  public source: string;
  public status: ReTradingErrorCodes;

  constructor(source: string, status: ReTradingErrorCodes, message: string) {
    super(source, status, message);
  }
}

export { ReTradingErrorCodes };
